<template>
  <v-btn icon :title="theme === 'dark' ? 'Thème clair' : 'Thème sombre'" :aria-label="theme === 'dark' ? 'Passer en thème clair' : 'Passer en thème sombre'" @click="toggle">
    <v-icon>{{ theme === 'dark' ? 'light_mode' : 'dark_mode' }}</v-icon>
  </v-btn>
</template>

<script>
  import { applyTheme, initialTheme } from '@/plugins/theme'

  // Bascule clair / sombre de la barre du haut ; le choix est mémorisé par applyTheme
  export default {
    name: 'ThemeToggle',
    data () {
      return { theme: initialTheme() }
    },
    methods: {
      toggle () {
        this.theme = applyTheme(this.$vuetify, this.theme === 'dark' ? 'light' : 'dark')
      }
    },
    mounted () {
      applyTheme(this.$vuetify, this.theme)
    }
  }
</script>
